import React from 'react';
import PropTypes from 'prop-types';

export function WarrantyShortDescriptionLine(props) {
  const { label, value } = props;

  return (
    <div className="d-flex text-cool-gray-40">
      <div className="fw-medium me-0_5">{label}</div>
      <div className="ms-auto text-end">{value}</div>
    </div>
  );
}

WarrantyShortDescriptionLine.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};
